module.exports = __webpack_public_path__ + "static/media/pc_bg.d6415606.jpg";